// extracted by mini-css-extract-plugin
export default {"cls1":"VeloCardHeader-StyledHeader_cls1__Rur85","cls2":"VeloCardHeader-StyledHeader_cls2__TMMlq VeloCardHeader-StyledHeader_cls1__Rur85"};